export default __webpack_public_path__ + "static/150-7a27e45aa0058e60b0503b549e97e8c9.jpg";